var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 33L28.514 28.506L33 33ZM31 22.5C31 24.7543 30.1045 26.9163 28.5104 28.5104C26.9163 30.1045 24.7543 31 22.5 31C20.2457 31 18.0837 30.1045 16.4896 28.5104C14.8955 26.9163 14 24.7543 14 22.5C14 20.2457 14.8955 18.0837 16.4896 16.4896C18.0837 14.8955 20.2457 14 22.5 14C24.7543 14 26.9163 14.8955 28.5104 16.4896C30.1045 18.0837 31 20.2457 31 22.5V22.5Z",
    stroke: "#989898",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBg);
export default __webpack_public_path__ + "static/media/searchBG.3086407360adca54fa2bc2141a3a5948.svg";
export { ForwardRef as ReactComponent };